var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"9.5","stroke":"#A2BBAC","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.00009 7.00002C9.00009 6.44773 8.55237 6.00002 8.00009 6.00002C7.4478 6.00002 7.00009 6.44773 7.00009 7.00002V13C7.00009 13.5523 7.4478 14 8.00009 14C8.55237 14 9.00009 13.5523 9.00009 13L9.00009 7.00002ZM10.9998 13C10.9998 13.5523 11.4476 14 11.9998 14C12.5521 14 12.9998 13.5523 12.9998 13L12.9998 7.00002C12.9998 6.44773 12.5521 6.00002 11.9998 6.00002C11.4476 6.00002 10.9998 6.44773 10.9998 7.00002L10.9998 13Z","fill":"#A2BBAC","key":1})]);
}

Pause.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
